import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { useTicketCart } from '../../context/TicketCartContext';

export default function FloatingCartButton() {
  const { cartItems, toggleCart, getCartItemCount } = useTicketCart();
  const itemCount = getCartItemCount();

  if (itemCount === 0) return null;

  return (
    <AnimatePresence>
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={toggleCart}
        className="fixed bottom-6 right-6 z-40 bg-gradient-to-r from-violet-600 to-purple-600 text-white p-4 rounded-full shadow-lg shadow-violet-500/30 hover:shadow-violet-500/50 transition-shadow"
        data-testid="floating-cart-btn"
      >
        <ShoppingCart className="w-6 h-6" />
        
        {/* Badge */}
        <motion.span
          key={itemCount}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute -top-1 -right-1 bg-emerald-500 text-white text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center shadow-lg"
        >
          {itemCount > 99 ? '99+' : itemCount}
        </motion.span>
      </motion.button>
    </AnimatePresence>
  );
}
